// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7fa396b1","843":"416a4b39"}[chunkId] + ".chunk.js";
};